// extracted by mini-css-extract-plugin
module.exports = {"container":"ModifyPasswordSuccess_container___7sHJ","msg":"ModifyPasswordSuccess_msg__2rYQL","confirmBtn":"ModifyPasswordSuccess_confirmBtn__V4WpC"};